import { css } from "@emotion/core"
import { theme } from "../constants"

export const defaultBtnStyles = css`
  background: ${theme.colors.purple[400]};
  &:hover:enabled,
  &:active,
  &:focus {
    background: ${theme.colors.purple[400]};
    box-shadow: 0px 0px 20px ${theme.colors.purple[400]};
  }
`

export const primaryBtnStyles = css`
  background: ${theme.gradients.violetPink};
  &:hover:enabled,
  &:active,
  &:focus {
    background: ${theme.gradients.violetPink};
    box-shadow: 0px 0px 20px ${theme.colors.pink[400]};
  }
`
export const secondaryBtnStyles = css`
  background: ${theme.colors.pink[400]};
  &:hover:enabled,
  &:active,
  &:focus {
    background: ${theme.colors.pink[400]};
    box-shadow: 0px 0px 20px ${theme.colors.pink[400]};
  }
`

export const borderedBtnStyles = css`
  background: transparent;
  border: 1px solid ${theme.colors.text};
  &:hover:enabled,
  &:active,
  &:focus {
    border: 1px solid ${theme.colors.text};
    background: transparent;
    box-shadow: 0px 0px 20px ${theme.colors.text};
  }
`
export const coloredBorderedBtnStyles = css`
  background: transparent;
  border: solid 1px transparent;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0)
    ),
    linear-gradient(91.3deg, #6713d2 15.64%, #c91885 66.7%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  box-shadow: 2px 1000px 1px #17143d inset;
  span {
    text-align: center;
    background: -webkit-linear-gradient(91.3deg, #6713d2 15.64%, #c91885 66.7%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  &:hover,
  &:active {
    box-shadow: ${theme.shadows.colorBorder} !important; //to override ant style
    background: ${theme.background.borderButton} !important;
    border: none;
    span {
      -webkit-text-fill-color: $white;
    }
  }
  &:disabled {
    background: none !important;
  }
`

const btnTypeStyles = {
  default: defaultBtnStyles,
  primary: primaryBtnStyles,
  secondary: secondaryBtnStyles,
  bordered: borderedBtnStyles,
  colorBorder: coloredBorderedBtnStyles,
}

export const smallBtnStyles = css`
  min-height: 28px;
  max-height: 28px;
  min-width: 6.25em;
  padding: 5px 12px;
  font-size: ${theme.fontSizes[2]};
  border-radius: ${theme.radii[6]};
  width: fit-content;
`
export const largeBtnStyles = css`
  min-height: 40px;
  max-height: 40px;
  min-width: 16.82em;
  padding: 8px 16px;
  font-size: ${theme.fontSizes[4]};
  border-radius: ${theme.radii[11]};
  width: fit-content;
`
const btnSizeStyles = {
  large: largeBtnStyles,
  small: smallBtnStyles,
}

export const btnStyles = (btnType, btnSize) => {
  return css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.text};
    border: 0;
    font-weight: ${theme.fontWeights.semiBold};
    font-family: ${theme.fonts.primary};
    span:not(.anticon) {
      margin-left: 4px;
    }
    &:hover,
    &:active,
    &:focus {
      color: ${theme.colors.text};
    }
    &:disabled {
      opacity: 0.3;
      background: ${theme.colors.purple[900]};
      color: ${theme.colors.text};
      box-shadow: unset !important;
    }
    &::before {
      background: inherit !important;
    }
    ${btnSizeStyles[btnSize]};
    ${btnTypeStyles[btnType]};
  `
}
